export default __webpack_public_path__ + "static/media/38t.2eeffdb1.jpg";